// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDCS6OBzxsJ3tPMf21LzUyGeEem3dsZyFk',
  authDomain: 'inframet-ed230.firebaseapp.com',
  projectId: 'inframet-ed230',
  storageBucket: 'inframet-ed230.appspot.com',
  messagingSenderId: '252589622508',
  appId: '1:252589622508:web:a9b0fc70b657e2ff4f11c9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;
